import { UI_ACTIONS } from 'store/v1/ui/ui.constants.js';
import { PRODUCTIONS_ACTIONS } from 'store/v1/productions/productions.constants.js';

const INITIAL_STATE = {
  modalIsOpen: false,
  walkthroughIsOpen: false,
  currentModal: null,
  currentWalkthrough: null,
  modalCloseAction: null,
  data: {},
  /** Last browsing AppScope (slug form) from the most recent v1 modal open — kept through close for fade-out. */
  appScope: null,
  /**
   * Browsing AppScope from the most recent booking-sidebar open (slug form).
   * Separate from modal `appScope` so conflict modals do not overwrite it.
   */
  bookingSidebarAppScope: null,
  showContactSidebar: false,
  showProductionSidebar: false,
  showBookingSidebar: false,
  selectedContact: {},
  selectedProduction: {},
  selectedBooking: {}
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UI_ACTIONS.OPEN_MODAL:
      return {
        ...state,
        modalIsOpen: true,
        currentModal: action.modalType,
        data: action.data,
        appScope: action.appScope ?? null,
        modalCloseAction: action.modalCloseAction
      };
    case UI_ACTIONS.OPEN_WALKTHROUGH:
      return {
        ...state,
        walkthroughIsOpen: true,
        currentWalkthrough: action.section
      };
    case UI_ACTIONS.CLOSE_WALKTHROUGH:
      return {
        ...state,
        walkthroughIsOpen: false,
        currentWalkthrough: null
      };
    case UI_ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        modalIsOpen: false,
        walkthroughIsOpen: false,
        currentModal: null,
        currentWalkthrough: null,
        modalCloseAction: null,
        data: {}
      };
    case UI_ACTIONS.OPEN_CONTACT_SIDEBAR:
      return {
        ...state,
        showContactSidebar: true,
        // showProductionSidebar: false,
        selectedContact: action.selectedContact
      };
    case UI_ACTIONS.CLOSE_CONTACT_SIDEBAR:
      return {
        ...state,
        showContactSidebar: false,
        selectedContact: {}
      };
    case UI_ACTIONS.OPEN_PRODUCTION_SIDEBAR:
      return {
        ...state,
        showProductionSidebar: true,
        // showContactSidebar: false,
        selectedProduction: action.selectedProduction,
        productionSidebarOptions: action.options
      };
    case UI_ACTIONS.OPEN_BOOKING_SIDEBAR: {
      const { appScope = null, ...bookingSidebarOptions } =
        action.options || {};
      return {
        ...state,
        showBookingSidebar: true,
        showContactSidebar: false,
        selectedBooking: action.selectedBooking,
        bookingSidebarOptions,
        bookingSidebarAppScope: appScope
      };
    }
    case UI_ACTIONS.CLOSE_BOOKING_SIDEBAR:
    case UI_ACTIONS.CLOSE_PRODUCTION_SIDEBAR:
    case PRODUCTIONS_ACTIONS.DELETE_PRODUCTION_SUCCESS:
      return {
        ...state,
        showProductionSidebar: false,
        showBookingSidebar: false,
        selectedProduction: {},
        selectedBooking: {},
        productionSidebarOptions: {},
        bookingSidebarOptions: {},
        bookingSidebarAppScope: null
      };
    default:
      return state;
  }
};
